export const ALL_POI_TYPES = [
  {
    id: 2,
    slug: 'ramp',
    name: __('Boat Ramp'),
    description: __('Place to launch your boat into and out of the water.'),
  },
  {
    id: 4,
    slug: 'marina',
    name: __('Marina'),
    description: __('Moorings and supplies for yachts and small boats.'),
  },
  {
    id: 5,
    slug: 'bait-shop',
    name: __('Bait Shop'),
    description: __('Place to buy fishing bait and lures.'),
  },
  {
    id: 8,
    slug: 'license-vendor',
    name: __('License Vendor'),
    description: __('Place to buy a fishing license.'),
  },
  {
    id: 10,
    slug: 'charter',
    name: __('Charter'),
    description: __('Place to rent and charter boats.'),
  },
  {
    id: 11,
    slug: 'gear-and-equipment',
    name: __('Gear and Equipment'),
    description: __('Place to buy all the fishing equipment you need for your fishing trip.'),
  },
  {
    id: 13,
    slug: 'fly-fishing-shop',
    name: __('Fly Fishing Shop'),
    description: __('Place to buy fly fishing equipment, fly fishing reels, rods and flies.'),
  },
  {
    id: 14,
    slug: 'refuge',
    name: __('Fish Refuge or Hatchery'),
    description: __('Facility that helps protect fish, maintain fish populations, and provide fun fishing opportunities.'),
  },
  {
    id: 16,
    slug: 'national-park',
    name: __('National Park'),
    description: __('These are selected national parks operated by the U.S. National Park Service that are good for either fishing, boating, or both.'),
  },
];

export const ALL_POI_TYPE_IDS = (
  ALL_POI_TYPES.map((type) => type.id)
);

export const poiTypeIdToName = (typeId) => (
  (ALL_POI_TYPES.find((type) => type.id === typeId) || {}).slug
);

export const poiTypeIdToEnglishName = (typeId) => (
  (ALL_POI_TYPES.find((type) => type.id === typeId) || {}).name
);

export const poiTypeNameToEnglishName = (typeName) => (
  (ALL_POI_TYPES.find((type) => type.slug === typeName) || {}).name
);
